import { getProductAliasFromType } from '../../lib/productHelpers';
import { retailerSettingsService } from '../retailer-settings/retailer-settings';
import { orderService } from '../order-service/order-service';
import { setCartActions } from '../../actions/returnItems';
import { store } from '../../store';

const returnItemsServiceFunction = () => {
  const returnOrder = {};
  const EXCHANGE = getProductAliasFromType('exchange');
  const exchangeEnabled = retailerSettingsService.getIsExchangeEnabled();
  let totalSelected = 0;

  returnOrder.order_number = '';
  returnOrder.return_method = '';
  returnOrder.return_items = [];

  const addOrder = ({ order_number: orderNumber, gift }) => {
    const customerId = orderService.getCustomerId();
    returnOrder.order_number = orderNumber;
    returnOrder.customer_id = customerId;
    returnOrder.gift = gift;
  };

  const updateCartActions = () => {
    store.dispatch(
      setCartActions([...new Set(returnOrder.return_items.map(({ action_type }) => action_type))]),
    );
  };

  const addItem = (item) => {
    if (item.item_properties) {
      item.item_properties.forEach((property) => {
        if (property.key === 'Color') {
          item.item_color = property.value;
        }

        if (property.key === 'Size') {
          item.item_size = property.value;
        }
      });
    }

    returnOrder.return_items.push(item);
    updateCartActions();

    return true;
  };

  const updateMethod = (method) => {
    returnOrder.return_method = method;
  };

  const getItems = () => returnOrder.return_items;

  const getReturnItemsCount = () => returnOrder.return_items.length;

  const isExchangesOnly = () =>
    exchangeEnabled && returnOrder.return_items.every((item) => item.product === EXCHANGE);

  const getReturnOrder = () => returnOrder;

  const getMethod = () => returnOrder.return_method;

  const getMethodCarrier = () => returnOrder.return_carrier;

  const clearReturn = () => {
    returnOrder.return_items = [];
    totalSelected = 0;
  };

  const hasAnExchange = () =>
    exchangeEnabled && returnOrder.return_items.some((item) => item.product === EXCHANGE);

  const putGift = (giftInfo) => {
    returnOrder.gift = giftInfo.checkbox;
    returnOrder.gift_email_address = giftInfo.email;
  };

  const getTotalSelected = () => {
    let tempCount = 0;

    for (let i = 0; i < returnOrder.return_items.length; i += 1) {
      tempCount += returnOrder.return_items[i].return_qty;
    }

    totalSelected = tempCount;

    return totalSelected;
  };

  const removeItem = (item) => {
    const index = returnOrder.return_items.indexOf(item);

    if (index !== -1) {
      returnOrder.return_items.splice(index, 1);
    }
    updateCartActions();
  };

  const removeItemById = (item) => {
    for (let i = 0; i < returnOrder.return_items.length; i += 1) {
      if (item.item_id === returnOrder.return_items[i].item_id) {
        returnOrder.return_items.splice(i, 1);
      }
    }
    updateCartActions();
  };

  const removeItemByName = (removeName) => {
    const itemNames = returnOrder.return_items.map((orderItem) => orderItem.item_name);
    const removeIndex = itemNames.indexOf(removeName);

    if (removeIndex >= 0) {
      returnOrder.return_items.splice(removeIndex, 1);
    }

    updateCartActions();
    return removeIndex;
  };

  return {
    addOrder,
    addItem,
    updateMethod,
    getItems,
    getReturnItemsCount,
    isExchangesOnly,
    getReturnOrder,
    getMethod,
    getMethodCarrier,
    hasAnExchange,
    clearReturn,
    putGift,
    getTotalSelected,
    removeItem,
    removeItemById,
    removeItemByName,
    updateCartActions,
  };
};

export const returnItemsService = returnItemsServiceFunction();
